import React from 'react';
import { connect } from 'react-redux';
import { Button, Accordion } from 'react-bootstrap';
import moment from 'moment';
import Draggable from 'react-draggable';
import _ from 'lodash';

import { trackChartPointDetailsView } from '../../util/mixpanel';
import { isWhite } from '../../util/colors';
import { formatWorkDuration } from '../../util/dates';

import closeIcon from '../../assets/img/x.svg';
import DetailStats from './DetailStats';

export class DDPDetailsAccordion extends React.Component {
  constructor(props) {
    super(props);

    if (props.test) {
      this.state = {
        show: true,
        data: props.data
      }
    } else {
      this.state = {
        show: false,
        data: {}
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data != this.props.data) {
      this.setState({
        show: true,
        data: this.props.data
      });
    }
  }

  handleClose = () => {
    this.setState({
      show: false,
      data: {}
    });

    trackChartPointDetailsView('ddp', false);
  };

  renderDetail(d, y, bl, blockedTime, label, blockers, isLongest) {
    const ct = formatWorkDuration(d.cycleTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const blockedList = _.find(bl, { listId: d.listId });
    const showBlockerInfo = blockers !== false && blockedTime === 'all';

    return (
      <p key={y} className={`detail-stage ${isLongest ? 'detail-stage--main' : ''}`}>
        <span className="detail-stage-name">{label}{' '}{d.list}</span>{' '}
        <span className="detail-stage-value">
        {ct}
        {showBlockerInfo && !!blockedList && (
          <span className="detail-stage-blocked">
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
          </span>
        )}
        </span>
      </p>
    );
  }

  render() {
    const { show, data } = this.state;
    const { cycleTime, estimated, points } = data;
    const { blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';

    return (
      <Draggable defaultPosition={{ x: 95, y: 85 }} axis="both" bounds="parent">
        {!show || !points ? (
          <div></div>
        ) : (
          <div id={this.props.id} className="box_white_shadow detailed_accordion">
            <div className='box_white_title mb-4'>
              <DetailStats
                stats={[
                  { label: 'Cycle time', value: cycleTime },
                  { label: 'Predicted time', value: estimated }
                ]}
              />
              <div className='right-actions'>
                <Button variant='secondary' size='sm' className="btn-action" onClick={this.handleClose}>
                  <img src={closeIcon} alt="close" />
                </Button>
              </div>
            </div>
            
            <Accordion>
              {points.map((point, i) => {
                return (
                  <Accordion.Item eventKey={i} key={i} activeKey={i === 0} className={showBlockerInfo && !!point.card.blockedTime && 'accordion-item-blocked-card'}>
                    <Accordion.Header>
                      <span className={`label_dot ${isWhite(point.color) ? 'label_dot--white' : ''}`} style={{ background: point.color }}></span>
                      {point.card.name}
                    </Accordion.Header>
                    <Accordion.Body>
                      {!!point.card.secondaryName && <p className="detail-summary">{point.card.secondaryName}</p>}
                      <p><span className="detail-label">End date:</span>{' '}<span className="detail-value">{moment(point.date).format(this.props.dateFormat)}</span></p>
                      <p>
                        <span className="detail-label">Predicted time:</span>{' '}<span className="detail-value">{formatWorkDuration(point.estimatedMinutes, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                      </p>
                      <p className="detail-meta">
                        {!!point.card.coloredField && <span>{point.card.coloredValue}</span>}
                        {/* named here: next to "Predicted time" a bare number would read as either */}
                        <span>{`${label || ''}Cycle time: `}{formatWorkDuration(_.sumBy(point.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                      </p>
                      {showBlockerInfo && blockedTime === 'all' && !!point.card.blockedTime && (
                        <p className='block-item'>
                          <span className="detail-label">Blocked time:</span>{' '}<span className="detail-value">{formatWorkDuration(point.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}</span>
                        </p>
                      )}
                      {/* a field breakdown: an item in one category has one row repeating the line above (the same name and the
                          same time) and, with no blocked time of its own, nothing else; that row is left out */}
                      {!(point.details.length === 1 && point.details[0].list === point.card.coloredValue &&
                        !(blockers !== false && blockedTime === 'all' && _.find(point.card.blockedLists, { listId: point.details[0].listId }))) &&
                        point.details.map((d, y) => {
                        return this.renderDetail(d, y, point.card.blockedLists, blockedTime, label, blockers, d === _.maxBy(point.details, 'cycleTime'));
                      })}
                      {!!point.card.url && (
                        <p>
                          <a href={point.card.url} target="_blank" className='btn btn-sm btn-light-secondary'>
                            Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
                          </a>
                        </p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          </div>
        )}
      </Draggable>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    dateFormat: state.filters.dateFormat,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(DDPDetailsAccordion);
